import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { IToast, ToastType } from '@ideenherd';

import { AccreditationConfigViewModel } from './core/view-models/accreditation-config.view-model';
import { CarViewModel } from './core/view-models/car.view-model';
import { EventViewModel } from './core/view-models/event.view-model';
import { UserViewModel } from './core/view-models/user.view-model';
import { AppointmentViewModel } from './core/view-models/appointment.view-model';
import { WorkshopViewModel } from './core/view-models/workshop.view-model';
import { UserWorkshopViewModel } from './core/view-models/user-workshop.view-model';
import { EventUserViewModel } from './core/view-models/event-user.view-model';
import { DataService } from '@ideenherd/core/data';
import { SINECTROUTES } from './app-routing.module';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
@Injectable({
  providedIn: 'root',
})
export class AppService {
  public allowedWorkshopUsers: UserWorkshopViewModel[] = [];
  public accreditationConfig: AccreditationConfigViewModel;
  public eventDetails: EventViewModel[];
  public carDetail: CarViewModel;
  public appointmentId: number;
  public updatedDriverindex: number;
  public driversList: UserViewModel[] = [];
  public carList: CarViewModel[] = [];
  public appointmentList: AppointmentViewModel[] = [];
  private backButtonSubject = new Subject<void>();
  public backButtonS$ = this.backButtonSubject.asObservable();
  public showBackButton = false;
  private notificationSubject: Subject<IToast> = new Subject();
  public notification$ = this.notificationSubject.asObservable();
  public currentDriverlist: UserViewModel[] = [];
  public workshopList: WorkshopViewModel[] = [];
  public activeWorkshopList: WorkshopViewModel[] = [];
  public closedWorkshopList: WorkshopViewModel[] = [];
  public participantList: EventUserViewModel[][][] = [];
  public checkedParticipantList: EventUserViewModel[][][] = [];
  public uncheckedParticipantList: EventUserViewModel[][][] = [];
  public workshopDetail: WorkshopViewModel;
  public workshopDetailParticipants: { checkIns: number, inscriptions: number };
  public workshopParticipantsIds: number[];
  public currentUserWorkshopDetail: UserWorkshopViewModel;
  public currentWorkshopId: string;
  public workShopUsers: UserWorkshopViewModel[] = [];
  public checkedWorkShopUsers: UserWorkshopViewModel[] = [];
  public uncheckedWorkShopUsers: UserWorkshopViewModel[] = [];
  public eventParticipantDetail: EventUserViewModel;
  private _accreditationConfigLoadedSubject: ReplaySubject<void> = new ReplaySubject<void>(1);
  public showLoader = false;
  public scannerProcessLoader: boolean;

  public workshopAvailablePlaces: number;

  constructor(private dataService: DataService, private router: Router) { }

  get accreditationConfigLoadedSubject(): ReplaySubject<void> {
    return this._accreditationConfigLoadedSubject;
  }

  get accreditationConfigLoaded(): Observable<void> {
    return this._accreditationConfigLoadedSubject.asObservable();
  }

  public callNotification(notification: IToast): void {
    this.notificationSubject.next(notification);
  }

  public callBackButton(): void {
    this.backButtonSubject.next();
  }

  public clearData(): void {
    this.carList = [];
    this.workshopList = [];
    this.participantList = [];
    this.checkedParticipantList = [];
    this.uncheckedParticipantList = [];
  }

  public prepareParticipantData(scannedParticipantId: number): void {
    this.clearParticipantData();
    for (const eventDetail of this.eventDetails) {

      const eventId = eventDetail.id;
      this.participantList[eventId] = [];
      this.checkedParticipantList[eventId] = [];
      this.uncheckedParticipantList[eventId] = [];

      this.dataService.getUsersEventByEventId(eventId).subscribe(userEvents => {
        userEvents
          .filter(participant => (participant.ue_u_.u_global_authorisation < 10)) // >= 10 are admin users
          .forEach(participant => {
            const eventUser = new EventUserViewModel(participant);
            const eventUserDays = eventUser.days.length > 0 ? eventUser.days : eventDetail.numberOfDays;

            for (const day of eventUserDays) {
              if (!this.participantList[eventId][day]) this.participantList[eventId][day] = [];
              if (!this.checkedParticipantList[eventId][day]) this.checkedParticipantList[eventId][day] = [];
              if (!this.uncheckedParticipantList[eventId][day]) this.uncheckedParticipantList[eventId][day] = [];

              if (eventUser.user.id === scannedParticipantId) {
                this.eventParticipantDetail = eventUser;
              }
              if (eventUser.isCheckedIn(day)) {
                this.checkedParticipantList[eventId][day].push(eventUser);
              } else {
                this.uncheckedParticipantList[eventId][day].push(eventUser);
              }
              this.participantList[eventId][day].push(eventUser);
            }
          });
      }, error => {
        console.error(error);
      }, () => {
        this.scannerProcessLoader = false;
        this.router.navigate([SINECTROUTES.PARTICIPANT_DETAIL]);
      });
    }
  }

  public checkInParticipant(scannedParticipantId: number, eventId: string, day: string): void {
    const participantRef = this.participantList[eventId][day].find(q => q.id === scannedParticipantId);
    const participant = participantRef?.eventUserData ? new EventUserViewModel(participantRef.eventUserData) : null;
    if (!participant) return;

    this.checkedParticipantList[eventId][day] = this.checkedParticipantList[eventId][day].filter(q => q.id !== scannedParticipantId);
    this.uncheckedParticipantList[eventId][day] = this.uncheckedParticipantList[eventId][day].filter(q => q.id !== scannedParticipantId);
    this.checkedParticipantList[eventId][day].push(participant);
  }

  public updateParticipantData(scannedParticipantId: number, isChecked: boolean, eventId: string, day: string): void {
    let removeFromArray: EventUserViewModel[] = [];
    let addToArray: EventUserViewModel[] = [];
    if (isChecked === true) {
      removeFromArray = this.uncheckedParticipantList[eventId][day];
      addToArray = this.checkedParticipantList[eventId][day];
    } else {
      removeFromArray = this.checkedParticipantList[eventId][day];
      addToArray = this.uncheckedParticipantList[eventId][day];
    }
    const participant = removeFromArray.find(item => item.user.id === scannedParticipantId);
    const participantIndex = removeFromArray.findIndex(item => item.user.id === scannedParticipantId);
    if (!participant) return;

    //participant.checked = isChecked;
    isChecked ? participant.checkIn(day) : participant.checkOut(day);
    addToArray.push(participant);
    removeFromArray.splice(participantIndex, 1);
  }

  public prepareWorkshopData(workshopId: number): UserWorkshopViewModel[] {
    const workShopUsers: UserWorkshopViewModel[] = [];
    this.clearWorkshopsData();
    this.dataService.getUsersWorkshopByWorkshopId(+workshopId).subscribe(data => {
      if (this.workshopDetail.maxParticipant != 0) {
        this.workshopAvailablePlaces = this.workshopDetail.maxParticipant - data?.length;
        if (this.workshopAvailablePlaces < 0) {
          this.workshopAvailablePlaces = 0;
        }
      } else {
        this.workshopAvailablePlaces = 0;
      }
      if (data?.length) {
        data.forEach(user => {
          const wsUser = new UserWorkshopViewModel(user);
          if (wsUser.checkInDate != null) {
            this.checkedWorkShopUsers.push(wsUser);
          } else {
            this.uncheckedWorkShopUsers.push(wsUser);
          }
          this.workShopUsers.push(wsUser);
        });
      }
    }, (error) => {
      console.error();
      this.showLoader = false;
    }, () => {
      this.workshopDetailParticipants = { inscriptions: this.workShopUsers.length, checkIns: this.getCheckInUsersNumber() }
      this.showLoader = false;
    })
    return workShopUsers;
  }


  clearParticipantData() {
    this.participantList = [];
    this.checkedParticipantList = [];
    this.uncheckedParticipantList = [];
  }

  public clearWorkshopsData(): void {
    this.checkedWorkShopUsers = [];
    this.uncheckedWorkShopUsers = [];
    this.workShopUsers = [];
  }

  public notrifyError(error: HttpErrorResponse): void {
    const notification: IToast = { message: "", type: ToastType.ERROR };
    if (error.status === 404) {
      notification.message = "Falscher Code";
      this.callNotification(notification);
    } else if (error.status === 500) {
      notification.message = "Interner Serverfehler";
      this.callNotification(notification);
    }
  }

  public getCheckInUsersNumber(): number {
    return this.workShopUsers.filter(user => user.checkInDate != undefined).length;
  }
}
